import React from 'react'
import formatDate from '../../../../../../utils/formatDate'

const JobSeekerEducation = ({ data }) => {
  return (
    <div className="candidate-profile my-3 border rounded border-primary">
      
      <div className="work-experience">
        <div>
          <h5 className="institute">{data["institute"]}</h5>
          <p className="degree">
            {" "}
            {data["category"] ? `${data["category"]} - ` : ""}{" "}
            {data["degree"]}
          </p>
          <p className="location">
            {data["city"]}, {data["country"]}
          </p>
          <p className="tenure">
            {data["start_date"] && formatDate(data["start_date"])} To{" "}
            {data["status"] === "Currently Studying"
              ? data["status"]
              : data["end_date"] && formatDate(data["end_date"])}
          </p>
          <p className="description">{data["description"]}</p>
        </div>
      </div>

    </div>
  )
}

export default JobSeekerEducation